module.exports = __webpack_public_path__ + "img/globe.7d7bc019.png";